import { apiFetch } from "../api-fetch";
import getWordEnding from "../helpers/get-word-ending";
import Toast from "../../components/modal/toast";


const updateReactionButtons = (buttons, state, count) => {
  buttons.forEach(button => {
    if (!button.hasAttribute("data-reaction-inactive")) {
      button.classList.toggle("marked", state);
    }
    
    let counter = button.querySelector("[data-reaction-count]");
    if (counter) counter.textContent = count;
    let ending = getWordEnding(count, [1, 2, 3]);
    button.setAttribute('data-ending', ending);
  });
}

document.addEventListener("click", (e) => {
  let reactionButton = e.target.closest("[data-reaction]");
  
  if (reactionButton) {
    if (reactionButton.reactionLoaded) return;

    if (!window.checkAuth()) return;

    let isDone = reactionButton.classList.contains("marked");

    let url = isDone ? reactionButton.dataset.undo : reactionButton.dataset.do;
    let reactionEntity = reactionButton.closest("[data-reaction-wrapper]");
    let data = new FormData();
    let token = isDone ? reactionButton.dataset.undoToken : reactionButton.dataset.doToken;

    if (token) {
      let tokenName = reactionButton.dataset.tokenName || "token";
      data.append(tokenName, token);
    }

    if (reactionEntity && reactionEntity.reactionLoaded) return;

    if (url) {
      reactionButton.reactionLoaded = true;
      if (reactionEntity) reactionEntity.reactionLoaded = true;
      reactionButton.setAttribute("data-loading", "");
      
      apiFetch(url, { method: "POST", body: data })
        .then(result => {
          reactionButton.reactionLoaded = false;
          if (reactionEntity) reactionEntity.reactionLoaded = false;
          reactionButton.removeAttribute("data-loading");

          if (result.success) {
            if (reactionEntity) {
              let reactionType = reactionButton.dataset.reaction;
              updateReactionButtons(Array.from(reactionEntity.querySelectorAll(`[data-reaction="${reactionType}"]`)), !isDone, result.count);
            } else {
              updateReactionButtons([reactionButton], !isDone, result.count);
            }
          } else if (result.error) {
            Toast.open(result.error, { state: "error" });
          }
        })
        .catch(err => {
          reactionButton.reactionLoaded = false;
          if (reactionEntity) reactionEntity.reactionLoaded = false;
          reactionButton.removeAttribute("data-loading");
          console.error(err);
        })
    }
  }
})